import React, { useState } from 'react';
import './SignUp.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUser, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Alert from "react-bootstrap/Alert";
import { useEffect } from 'react';
import axios from "axios";
import Cookies from "js-cookie";

const SignIn = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorEmailMessage, setEmailErrorMessage] = useState(false);
    const [errorConfirmeMessage, setConfirmeErrorMessage] = useState(false);
    const [errorPasswordMessage, setPasswordErrorMessage] = useState(false);
    const [errorBlockedMessage, setBlockedErrorMessage] = useState(false);
    const [errorArchivedMessage, setArchivedErrorMessage] = useState(false);

    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    useEffect(() => {
        const jwtCookie = Cookies.get("jwt");
        console.log(jwtCookie)

        if (jwtCookie) {
            // If JWT cookie exists, redirect to profile page
            console.log(jwtCookie)
            localStorage.setItem("jwtToken", jwtCookie);
        }
    }, []);
    useEffect(() => {
        document.body.classList.add('fade-in-slide-up');
        return () => {
            document.body.classList.remove('fade-in-slide-up');
        };
    }, []);


    const handleSignIn = (e) => {
        e.preventDefault();

        axios
            .post("https://stage-cni-backend.vercel.app/login", {
                email: email,
                password: password,
            })
            .then((response) => {
                Cookies.set("jwt", response.data.token);

                localStorage.clear();
                localStorage.setItem("jwtToken", response.data.token);

                setTimeout(function () {
                    console.log("The anonymous function has been executed!");
                }, 500);

                navigate("/");
                navigate(0);
            })
            .catch((error) => {
                if (error.response.data.errors.email) {
                    setEmailErrorMessage(true);
                    setPasswordErrorMessage(false);
                    setConfirmeErrorMessage(false)
                    setBlockedErrorMessage(false);
                    setArchivedErrorMessage(false);
                }
                if (error.response.data.errors.confirmed) {
                    setEmailErrorMessage(false);
                    setPasswordErrorMessage(false);
                    setConfirmeErrorMessage(true)
                    setBlockedErrorMessage(false);
                    setArchivedErrorMessage(false);
                }
                if (error.response.data.errors.password) {
                    setEmailErrorMessage(false);
                    setPasswordErrorMessage(true);
                    setConfirmeErrorMessage(false)
                    setBlockedErrorMessage(false);
                    setArchivedErrorMessage(false);
                }
                if (error.response.data.errors.blocked) {
                    setEmailErrorMessage(false);
                    setPasswordErrorMessage(false);
                    setConfirmeErrorMessage(false)
                    setBlockedErrorMessage(true);
                    setArchivedErrorMessage(false);
                }
                if (error.response.data.errors.archived) {
                    setEmailErrorMessage(false);
                    setPasswordErrorMessage(false);
                    setConfirmeErrorMessage(false)
                    setBlockedErrorMessage(false);
                    setArchivedErrorMessage(true);
                }
            });
    };

    return (
        <div className="background-image overflow-hidden">
            <style>
                {`
                    .background-image {
                        background-image: url('../assetsTemplates/template1/img/carousel-4.jpg');
                        background-size: cover;
                        background-position: center;
                    }
                    .input-wrapper {
                        position: relative;
                    }
                    .toggle {
                        position: absolute;
                        top: 70%;
                        right: 10px;
                        transform: translateY(-50%);
                        cursor: pointer;
                    }
                `}
            </style>

            <div className="wrapper">
                <div className="container px-4 py-5 px-md-5 text-center text-lg-start my-5">
                    <div className="row gx-lg-5 align-items-center mb-5">
                        <div className="col-lg-6 mb-5 mb-lg-0" style={{ zIndex: 10 }}>
                        </div>
                        <div className="col-lg-6 mb-5 mb-lg-0 position-relative">
                            <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
                            <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>

                            <div className="card bg-glass">
                                <div className="card-body px-4 py-5 px-md-5">
                                    <div className="text-center my-5">
                                        <h3 className="font-weight-bold mb-3">Sign In</h3>
                                        <h3 className="text-muted font-italic fs-5">Sign in to the platform to continue</h3>
                                    </div>
                                    <form onSubmit={handleSignIn}>
                                        <div className="form-outline mb-4">
                                            <div className="input-wrapper">
                                                <label htmlFor="email">Email</label>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    className="form-control"
                                                    placeholder="Enter your email address"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                                <FontAwesomeIcon icon={faEnvelope} className="toggle" />
                                            </div>
                                        </div>
                                        {errorEmailMessage && (
                                            <Alert
                                                className="form-group"
                                                variant="danger"
                                                style={{ marginTop: "-13px" }}
                                            >
                                                <div
                                                    className="form-icon-wrapper  text-danger"
                                                    style={{ marginTop: "-11px", marginBottom: "-13px" }}
                                                >
                                                    email is not used
                                                </div>
                                            </Alert>
                                        )}
                                        {errorConfirmeMessage && (
                                            <Alert
                                                className="form-group"
                                                variant="danger"
                                                style={{ marginTop: "-13px" }}
                                            >
                                                <div
                                                    className="form-icon-wrapper  text-danger"
                                                    style={{ marginTop: "-11px", marginBottom: "-13px" }}
                                                >
                                                    Your account is not confirmed
                                                </div>
                                            </Alert>
                                        )}
                                        {errorBlockedMessage && (
                                            <Alert
                                                className="form-group"
                                                variant="danger"
                                                style={{ marginTop: "-13px" }}
                                            >
                                                <div
                                                    className="form-icon-wrapper  text-danger"
                                                    style={{ marginTop: "-11px", marginBottom: "-13px" }}
                                                >
                                                    Sorry your account is blocked
                                                </div>
                                            </Alert>
                                        )}
                                        {errorArchivedMessage && (
                                            <Alert
                                                className="form-group"
                                                variant="danger"
                                                style={{ marginTop: "-13px" }}
                                            >
                                                <div
                                                    className="form-icon-wrapper  text-danger"
                                                    style={{ marginTop: "-11px", marginBottom: "-13px" }}
                                                >
                                                    Sorry your account is archived
                                                </div>
                                            </Alert>
                                        )}

                                        <div className="form-outline mb-4">
                                            <div className="input-wrapper">
                                                <label htmlFor="password">Password</label>
                                                <input
                                                    type={showPassword ? 'text' : 'password'}
                                                    id="password"
                                                    className="form-control"
                                                    placeholder="Enter your password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <FontAwesomeIcon
                                                    icon={showPassword ? faEyeSlash : faEye}
                                                    className="toggle"
                                                    onClick={togglePasswordVisibility}
                                                />
                                            </div>
                                        </div>
                                        {errorPasswordMessage && (
                                            <Alert
                                                className="form-group"
                                                variant="danger"
                                                style={{ marginTop: "-13px" }}
                                            >
                                                <div
                                                    className="form-icon-wrapper  text-danger"
                                                    style={{ marginTop: "-11px", marginBottom: "-13px" }}
                                                >
                                                    incorrect password
                                                </div>
                                            </Alert>
                                        )}
                                        <div className="d-flex justify-content-between align-items-center">
                                            <button type="submit" className="btn btn-primary btn-block mb-4">
                                                Sign In
                                            </button>
                                            <div className="forget-password text-right">
                                                <NavLink to="/ForgotPassword">
                                                    Forgot password?
                                                </NavLink>
                                            </div>
                                        </div>
                                    </form>
                                    <div className="text-center mt-3">
                                        <p>
                                            Don't have an account? <NavLink to="/SignUp">Create your account</NavLink>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignIn;
